<script>
import { getComponent } from "./ComponentTypes"
import formConfig from "../../config/formConfigPsd2html.json"

export default {
  name: "form-config-provider-psd2html",
  functional: true,
  render(createElement) {
    let fieldObjects = formConfig.map(field => {
      let component = getComponent(field.type)
      return { ...field, component }
    })
    return createElement(getComponent("formTemplate"), {
      props: {
        formFields: fieldObjects
      }
    })
  }
}
</script>